var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export var ArrowRightIcon = function (props) {
    var role = 'button';
    var nextProps = __assign(__assign({}, props), { role: role });
    return (React.createElement(SvgIcon, __assign({}, nextProps),
        React.createElement("path", { d: "M17.6852189,12.7153289 L8.99273807,20.8407838 C8.7656355,21.0530721 8.39742949,21.0530721 8.17032692,20.8407838 C7.94322436,20.6284955 7.94322436,20.2843083 8.17032692,20.07202 L16.8056439,12 L8.17032692,3.92798001 C7.94322436,3.71569174 7.94322436,3.37150446 8.17032692,3.1592162 C8.39742949,2.94692793 8.7656355,2.94692793 8.99273807,3.1592162 L17.6852189,11.2846711 C18.0980805,11.670601 18.1058197,12.3037227 17.702505,12.6987879 C17.6968105,12.7043659 17.6910481,12.7098799 17.6852189,12.7153289 Z" })));
};
//# sourceMappingURL=ArrowRightIcon.js.map